import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './my-toolbox.component'

import RegistrationContactsBlock from '../common/registration-contacts-block'

let module = angular.module('myToolbox', [
  uiRouter,
  RegistrationContactsBlock
])
.config(($stateProvider) => {
  'ngInject'
  $stateProvider
    .state('registration.myToolbox', {
      url: '/my-toolbox?civility&lastName&firstName&email&model&friendlyName&vin',
      params: {
        password: null
      },
      component: 'myToolbox'
    })
})
.component('myToolbox', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/registration/my-toolbox/index.js